export default {
  namespaced: true,
  state: () => ({
    messages: []
  }),
  getters: {
    messages: state => {
      return state.messages
      // const msgs = state.messages.slice(0)
      // return msgs.reverse()
    },
    chatId: state => {
      if (state.messages.length === 0) {
        return null
      }
      return state.messages[0].chat_space_id
    }
  },
  mutations: {
    setMessages (state, messages) {
      state.messages = messages
    },
    reset (state) {
      state.messages = []
    },
    push (state, message) {
      state.messages.push(message)
    },
    unshift (state, message) {
      state.messages.unshift(message)
    }
  }
}
